<template>
	<div @keyup.enter="validate()" class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Fecha de vencimiento</h4>
				</div>
				<div class="modal-body" :class="{ 'disabled' : loading }">
					<template v-if="dueDates">
						<template v-if="dueDates.length">
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label class="control-label">Opciones disponibles</label>
										<select @change="dueDateSelected" v-model="dueDate" class="form-control">
											<option v-for="due_date in dueDates" :value="due_date">{{ due_date.name }}</option>
										</select>
									</div>
								</div>
							</div>
						</template>
					</template>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label class="control-label">Fecha</label>
								<input @change="dateSelected" type="date" v-model="date" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('due_date') }">
								<label class="control-label">Fecha de vencimiento</label>
								<input
								v-validate="'required'"
								name="due_date"
								readonly
								data-vv-as="Fecha de vencimiento"
								v-model="due_date"
								type="text"
								class="form-control"/>
								<small v-show="errors.has('due_date')" class="form-text text-danger">
									{{ errors.first('due_date') }}
								</small>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button ref="btnSave" :disabled="loading" @click="validate" type="button" class="btn btn-success">Guardar</button>
					<button v-if="data.due_date" ref="btnDestroy" :disabled="loading" @click="destroyDueDate" type="button" class="btn btn-danger">Eliminar</button>
					<button type="button" :disabled="loading" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data'],
		data () {
			return {
				modal: {
					selector: 'modal-invoice-due-date'
				},

				date: null,

				dueDates: null,
				dueDate: null,

				due_date: null,

				loading: false,
			}
		},
		methods: {
			open() {
				this.clearData()
				this.due_date = this.data.due_date
				var modal = $('#'+this.modal.selector)
				modal.modal('show')

				this.getDueDates()
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.errors.clear()
				this.dueDate = null
				this.date = null
			},
			getDueDates() {
				this.$http.get('admin/management/due/dates')
				.then(response => {
					this.dueDates = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			dueDateSelected() {
				if(this.dueDate) {
					this.due_date = this.dueDate.name
				}
			},
			dateSelected() {
				this.due_date = moment(this.date).format('LL')
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.updateDueDate()
					}
					return result
				})
			},
			updateDueDate() {
				this.loading = true
				var loading = Ladda.create(this.$refs.btnSave)
				loading.start()
				var data = {
					due_date: this.due_date
				}
				this.$http.post('admin/management/invoices/' + this.data.id + '/change/duedate', data)
				.then(response => {
					this.close()
					this.loading = false
					loading.stop()
					this.$emit('reload')
					swal(response.body.title, response.body.text, response.body.type)
				}).catch(response => {
					this.loading = false
					loading.stop()
					this.$emit('reload')
				})
			},
			destroyDueDate() {
				this.loading = true
				var loading = Ladda.create(this.$refs.btnDestroy)
				loading.start()
				var data = {
					due_date: null
				}
				this.$http.post('admin/management/invoices/' + this.data.id + '/change/duedate', data)
				.then(response => {
					this.close()
					this.loading = false
					loading.stop()
					this.$emit('reload')
					swal(response.body.title, response.body.text, response.body.type)
				}).catch(response => {
					this.loading = false
					loading.stop()
					this.$emit('reload')
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/DueDate.vue